"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M19.921 0a.52.52 0 0 1 .521.52.521.521 0 0 1-.427.51l-.094.01h-.283l-.022.578a46.65 46.65 0 0 1-.06 1.062c.916-.51 1.581-.25 1.907-.037 1.445.94 1.796 4.4.721 7.12-1.108 2.807-4.301 5.65-5.532 6.675l-.492.397-.03.02a14.047 14.047 0 0 1-1.586 2.381c1.33.455 2.62 1.586 2.724 3.204l.007.214v.826a.521.521 0 0 1-.427.512l-.094.008h-9.5a.52.52 0 0 1-.511-.426l-.009-.094v-.825c0-1.732 1.343-2.944 2.731-3.419a13.701 13.701 0 0 1-1.39-2.025l-.212-.383-.389-.297c-1.153-.907-4.503-3.718-5.65-6.619-1.095-2.775-.73-6.307.751-7.269.323-.21.98-.469 1.877.023l-.03-.489a41.71 41.71 0 0 1-.04-.817l-.012-.32h-.283A.52.52 0 0 1 3.994.008L4.087 0h15.834Zm-6.729 20.041h-2.376c-1.383 0-2.924 1.036-3.036 2.449l-.007.164v.307h8.463v-.307c0-1.44-1.49-2.53-2.884-2.608l-.16-.005ZM18.596 1.04H5.411l.038.808c.19 3.378 1.056 12.43 4.964 16.902l.23.253h2.723c4.257-4.536 5.063-14.423 5.211-17.519l.02-.444ZM6.5 1.585c.281 0 .532.205.55.488l.053.764c.28 3.686 1.23 11.023 4.411 14.766a.52.52 0 1 1-.792.672c-3.62-4.262-4.5-12.707-4.71-16.14a.52.52 0 0 1 .488-.55ZM4.562 4.037c-.415-.404-.987-.808-1.42-.524-.948.617-1.288 3.644-.352 6.017.77 1.95 2.746 3.941 4.082 5.135C5.448 11.05 4.83 6.93 4.562 4.037Zm16.335-.523c-.44-.292-1.028.127-1.45.542-.269 2.866-.88 6.951-2.288 10.546l.44-.415c1.29-1.248 2.932-3.066 3.62-4.805.915-2.32.594-5.272-.322-5.868Z",
    clipRule: "evenodd"
  })]
});